export default __webpack_public_path__ + "static/media/SWZ.faa0ead6.svg";